/* eslint-disable @typescript-eslint/no-explicit-any */

import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const outgoingBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'applications',
    url: '/applications/outgoing'
  },
  {
    label: 'outgoing',
    active: true
  }
];

export type OutgoingType = {
  orders: string;
  sender: string;
  recipient: string;
  currency: string;
  status: string;
  create_date: string;
  guid: string;
  gupid: number;
  can_update: boolean;
  status_pid: number;
};

export type OutgoingResult = {
  product_name: string;
  barcode: string;
  currency: string;
  units: string;
  cost: any;
  amount: string;
  history: string;
  status: string;
  guid: string;
  gupid: number;
  discount_percentage: string;
  prevCost: string;
  update_price: boolean;
  discount_id: string;
  package_quantity: any;
  measure_unit_pid: any;
  quantity_fact: any;
  quantity_accept: any;
  measure_unit_kind_pid: any;
  can_update_order_item: boolean;
  total_price: any;
  amount_discrepancies: any;
  discrepancies: any;
  status_pid: number;
};
